<template>
  <div>
    <header class="header-component">
      <dx-toolbar class="header-toolbar">
        <dx-item
          :visible="menuToggleEnabled"
          location="before"
          css-class="menu-button"
        >
          <!-- eslint-disable vue/no-unused-vars -->
          <dx-button
            icon="menu"
            styling-mode="text"
            @click="toggleMenuFunc"
            slot-scope="_"
          />
          <!-- eslint-enable -->
        </dx-item>

        <dx-item
          v-if="title"
          location="before"
          css-class="header-title dx-toolbar-label"
        >
          <!-- eslint-disable vue/no-unused-vars -->
          <div slot-scope="_">
            {{ title }}
            <b> - {{ empresa }} </b>
            <div class="modulo">
              <label>
                {{ modulo }}
                <!-- <q-badge @click="popup()" rounded align="top" color="red" label="Manual"/>-->
              </label>
            </div>
            <div class="modulo" v-if="1 == 0">
              {{ hoje }}
            </div>
          </div>

          <!-- eslint-enable -->
        </dx-item>

        <dx-item v-if="this.celular == 0" class="img" location="before">
          <img
            v-if="!caminho == ''"
            class="img"
            v-bind:src="pegaImg()"
            alt=""
          />
        </dx-item>

        <dx-item v-show="qt_aniversario > 0" location="after">
          <div v-show="qt_aniversario > 0" slot-scope="_">
            <!--<div class="badge">
              <span>
                {{ qt_aniversario }}
              </span>
            </div>-->

            <q-btn
              @click="onAniversariantes()"
              flat
              round
              color="cyan-8"
              icon="cake"
            >
              <q-tooltip self="center middle" class="bg-black">
                Aniversariantes
              </q-tooltip>
              <q-badge rounded color="red" floating>{{
                qt_aniversario
              }}</q-badge>
            </q-btn>
            <!--<DxButton
              class="btn"
              icon="fas fa-birthday-cake"
              type="gbs"
              @click="onAniversariantes()"
            >
              <q-tooltip self="center middle" class="bg-black">
                Aniversariantes
              </q-tooltip>
            </DxButton>-->
          </div>
        </dx-item>
        <dx-item location="center">
          <div
            class="text-weight-medium dt-storage"
            slot-scope="_"
            @click="popupData = true"
            v-if="data_tela_inicial != '' && data_tela_final != ''"
          >
            <q-badge color="empresa-cor" rounded>
              {{ data_tela_inicial }}
            </q-badge>
            até
            <q-badge color="empresa-cor" rounded>
              {{ data_tela_final }}
            </q-badge>
          </div>
          <div
            class="text-weight-medium "
            slot-scope="_"
            @click="popupData = true"
            v-else
          >
            <q-badge color="empresa-cor" rounded>
              Selecione a Data
            </q-badge>
          </div>
        </dx-item>

        <dx-item location="after" v-show="qt_suporte > 0">
          <div slot-scope="_">
            <!--<div class="badge">
              <span>
                {{ qt_suporte }}
              </span>
            </div>

            <DxButton
              id="suporte"
              class="btn"
              icon="fa fa-list-alt"
              type="gbs_orange"
              @click="onSuporte()"
            >
              <q-tooltip self="center middle" class="bg-black">
                Atendimentos
              </q-tooltip>
            </DxButton>-->

            <q-btn
              v-show="qt_suporte > 0"
              flat
              dense
              color="cyan-7"
              round
              icon="support_agent"
              class="q-ml-md"
            >
              <q-badge rounded color="cyan-7" floating>{{
                qt_suporte
              }}</q-badge>
              <q-tooltip self="center middle" class="bg-black">
                Atendimentos
              </q-tooltip>
            </q-btn>
          </div>
        </dx-item>

        <dx-item location="after">
          <div v-if="qt_financeiro > 0" slot-scope="_">
            <div class="badge">
              <span>
                {{ qt_financeiro }}
              </span>
            </div>

            <DxButton
              class="btn"
              icon="fas fa-coins"
              type="gbs_red"
              @click="onFinanceiro()"
            >
              <q-tooltip self="center middle" class="bg-black">
                Pendências Financeiras
              </q-tooltip>
            </DxButton>
          </div>
        </dx-item>

        <dx-item location="after">
          <div v-if="qt_atividade > 0" slot-scope="_">
            <div class="badge">
              <span>
                {{ qt_atividade }}
              </span>
            </div>

            <DxButton
              class="btn"
              icon="far fa-bell"
              type="gbs"
              @click="onAtividade()"
            >
              <q-tooltip self="center middle" class="bg-black">
                Atividades
              </q-tooltip>
            </DxButton>
          </div>
        </dx-item>

        <dx-item location="after">
          <div v-if="qt_informativo > 0" slot-scope="_">
            <div class="badge">
              <span>
                {{ qt_informativo }}
              </span>
            </div>

            <DxButton
              class="btn"
              icon="fas fa-info"
              type="gbs"
              @click="onInformativo()"
            >
              <q-tooltip self="center middle" class="bg-black">
                Informativo
              </q-tooltip>
            </DxButton>
          </div>
        </dx-item>

        <dx-item location="after">
          <div v-if="qt_mensagem > 0" slot-scope="_">
            <div class="badge">
              <span>
                {{ qt_mensagem }}
              </span>
            </div>

            <DxButton
              class="btn"
              icon="far fa-envelope"
              type="outro"
              @click="onMensagem()"
            >
              <q-tooltip self="center middle" class="bg-black">
                Mensagens
              </q-tooltip>
            </DxButton>
          </div>
        </dx-item>

        <dx-item
          location="after"
          locate-in-menu="auto"
          menu-item-template="menuUserItem"
        >
          <div slot-scope="_">
            <dx-button
              class="user-button authorization"
              :width="230"
              height="100%"
              styling-mode="text"
            >
              <user-panel :menu-items="userMenuItems" menu-mode="context" />
            </dx-button>
          </div>
        </dx-item>
        <dx-item location="after" round>
          <div slot-scope="_">
            <q-btn color="empresa-cor" round flat icon="settings">
              <q-menu fit style="min-width: 200px;height: auto">
                <q-list style="min-width: 200px;" class="lista-menu">
                  <q-item
                    clickable
                    v-close-popup
                    @click="$q.fullscreen.toggle()"
                  >
                    <q-item-section>
                      <q-btn
                        flat
                        round
                        color="empresa-cor"
                        icon="copy_all"
                      />Tela Inteira
                    </q-item-section>
                  </q-item>
                  <q-item
                    clickable
                    v-close-popup
                    id="dt-response"
                    class="row items-center"
                    @click="popupData = true"
                  >
                    <q-item-section class="col items-center ">
                      <q-badge color="empresa-cor" rounded>
                        {{ data_tela_inicial }}
                      </q-badge>
                      até
                      <q-badge color="empresa-cor" rounded>
                        {{ data_tela_final }}
                      </q-badge>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-menu>
            </q-btn>
          </div>
        </dx-item>

        <user-panel
          :menu-items="userMenuItems"
          menu-mode="list"
          slot-scope="_"
          slot="menuUserItem"
        />
      </dx-toolbar>
      <q-tabs
        align="left"
        v-model="tab"
        v-show="menuTabs.length > 0"
        inline-label
        class="bg-empresa-cor text-white tab-header"
        @click="clickTab()"
      >
        <q-tab
          v-for="(ta, tabIndex) in menuTabs"
          :key="tabIndex"
          :name="ta.path"
          :label="ta.name"
          class="tab-header"
        />
      </q-tabs>
    </header>

    <q-dialog v-model="popupData">
      <q-card>
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">Seleção de Data</div>
          <q-space />
          <q-btn
            icon="close"
            @click="selecaoPeriodoData()"
            flat
            round
            dense
            v-close-popup
          />
        </q-card-section>
        <selecaoData @click="fechaPopup()" :cd_volta_home="1"></selecaoData>
      </q-card>
    </q-dialog>

    <q-dialog v-model="alert">
      <q-card>
        <q-card-section>
          {{ modulo }}
        </q-card-section>
        <q-card-section>
          <q-video :src="pegaVideo()" />
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog seamless full-width v-model="collapse" position="top">
      <q-card class="collapse-card">
        <q-bar style="background-color: #F63B00">
          <q-space />
          <q-btn
            dense
            flat
            @click="this.collapse = false"
            icon="close"
            v-close-popup
          >
            <q-tooltip class="bg-white text-primary">Close</q-tooltip>
          </q-btn>
        </q-bar>
        <q-card-section class="row no-wrap">
          <div style="text-align: center; width: 30%">
            <q-card flat bordered class="my-card collapse-card">
              <q-card-section>
                <img
                  src="https://www.egisnet.com.br/img/logo_gbstec_sistema.png"
                  alt=""
                />
                <div style="text-align: center" class="text-h6">
                  Horário de Funcionamento
                </div>
              </q-card-section>

              <q-card-section style="text-align: center" class="q-pt-none">
                Horário: 08:00 - 18:00 <br />
                (Segunda á Sexta-Feira) <br />
                Fone: +55 11 3907-4141
              </q-card-section>

              <q-separator />

              <q-card-section>
                <div style="justify-content: center;">
                  <div style="text-align: center" class="text-h6">
                    Chat Online
                  </div>
                  <DxButton
                    class="botao buttons-column"
                    :width="200"
                    text="Entrar no Chat"
                    type="default"
                    styling-mode="contained"
                    horizontal-alignment="left"
                    @click="chatOnline()"
                  />
                </div>
              </q-card-section>
            </q-card>
          </div>

          <div class="col">
            <q-card flat bordered class="my-card collapse-card">
              <q-card-section>
                <div style="text-align: center" class="text-h6">Contato</div>
              </q-card-section>

              <q-card-section style="text-align: center" class="q-pt-none">
                <q-input v-model="nm_nome_contato" label="Nome" />
                <q-input v-model="nm_email_contato" label="Email" />
                <q-option-group
                  v-model="group"
                  :options="options"
                  color="primary"
                  inline
                  type="checkbox"
                />
                <q-input
                  type="textarea"
                  v-model="nm_mensagem"
                  label="Mensagem"
                />
                <DxButton
                  class="botao buttons-column"
                  :width="200"
                  text="Enviar Email"
                  type="default"
                  styling-mode="contained"
                  horizontal-alignment="left"
                  @click="chatOnline()"
                />
              </q-card-section>
            </q-card>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>

    <Atividade v-if="this.ic_atividade == true"> </Atividade>
  </div>
</template>

<script>
import DxButton from "devextreme-vue/button";
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import auth from "../auth";
//
import Procedimento from "../http/procedimento";
import Menu from "../http/menu";
import UserPanel from "./user-panel";
import Rota from "../http/rota";

import Atividade from "../components/consultaAtividade";
import funcoesPadroes from "../http/funcoes-padroes";

export default {
  props: {
    menuToggleEnabled: Boolean,
    title: String,
    toggleMenuFunc: Function,
    logOutFunc: Function,
  },
  components: {
    DxButton,
    DxToolbar,
    DxItem,
    UserPanel,
    selecaoData: () => import("../views/selecao-periodo"),
    Atividade,
  },

  data() {
    return {
      caminho: "",
      empresa: "",
      destinatario: "",
      modulo: "",
      hoje: "",
      celular: 0,
      alert: false,
      collapse: false,
      options: [
        {
          label: "Visita",
          value: "1",
        },
        {
          label: "Treinamento",
          value: "2",
        },
        {
          label: "Conferencia",
          value: "3",
        },
        {
          label: "Suporte",
          value: "4",
        },
        {
          label: "Novas Funcionalidades",
          value: "5",
        },
      ],

      qt_atividade: 0,
      qt_informativo: 0,
      qt_mensagem: 0,
      qt_aniversario: 0,
      qt_financeiro: 0,
      qt_suporte: 0,
      ic_aniversario: "N",
      nm_nome_contato: "",
      nm_email_contato: "",
      nm_mensagem: "",
      tab: "",
      menuTabs: [],
      group: [],
      userMenuItems: [
        {
          text: "Usuário",
          icon: "user",
          onClick: this.onUsuarioClick,
          disabled: false,
          visible: true,
        },
        {
          text: "Período",
          icon: "event",
          onClick: this.selecaoPeriodoData,
          disabled: false,
          visible: true,
        },
        {
          text: "Módulos",
          icon: "fields",
          onClick: this.onModuloClick,
          disabled: false,
          visible: true,
        },
        {
          text: "Empresas",
          icon: "group",
          onClick: this.onEmpresaClick,
          disabled: false,
          visible: true,
        },
        {
          text: "Contato",
          icon: "mention",
          onClick: this.onContatoClick,
          disabled: false,
          visible: true,
        },
        {
          text: "Sair",
          icon: "runner",
          onClick: this.onLogoutClick,
        },
      ],
      dt_inicial: "",
      dt_final: "",
      popupData: false,
      ic_atividade: false,
      ic_informativo: false,
      data_tela_inicial: "",
      data_tela_final: "",
      polling: null,
      meses: [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
      ],
    };
  },

  async created() {
    this.empresa = localStorage.fantasia;
    this.destinatario = localStorage.nm_destinatario;
    this.modulo = localStorage.nm_modulo;
    this.caminho = localStorage.nm_caminho_logo_empresa;
    if (this.$store._mutations.SET_Usuario.nm_cor_empresa) {
      document.documentElement.style.setProperty(
        "--cor-principal",
        this.$store._mutations.SET_Usuario.nm_cor_empresa,
      );
    } else {
      document.documentElement.style.setProperty("--cor-principal", "#ff5722");
    }
    this.$store._mutations.SET_ConfigUsuario.ic_usuario_internet === "S"
      ? ""
      : (this.userMenuItems[0].visible = false);

    this.$store._mutations.SET_ConfigUsuario.ic_periodo_internet === "S"
      ? ""
      : (this.userMenuItems[1].visible = false);

    this.$store._mutations.SET_ConfigUsuario.ic_modulo_internet === "S"
      ? ""
      : (this.userMenuItems[2].visible = false);

    this.$store._mutations.SET_ConfigUsuario.ic_empresa_internet === "S"
      ? ""
      : (this.userMenuItems[3].visible = false);
    this.$store._mutations.SET_ConfigUsuario.ic_contato_internet === "S"
      ? ""
      : (this.userMenuItems[4].visible = false);

    this.hoje = new Date().toLocaleDateString();
    this.polling = setInterval(() => {
      let dt1 = localStorage.dt_inicial;
      let dt2 = localStorage.dt_final;
      if (dt1 == "" || dt1 == undefined || dt1 == null) {
        this.data_tela_inicial = "";
        return;
      } else if (dt2 == "" || dt2 == undefined || dt2 == null) {
        this.data_tela_final = "";
        return;
      }
      //--------------------------------------------------------
      this.data_tela_inicial = new Date(
        localStorage.dt_inicial,
      ).toLocaleDateString();
      if (this.data_tela_inicial == "Invalid Date") {
        localStorage.dt_inicial = funcoesPadroes.getDataInicial();
        var mesI = localStorage.dt_inicial.substring(0, 2);
        var diaI = localStorage.dt_inicial.substring(3, 5);
        var anoI = localStorage.dt_inicial.substring(6, 10);
        mesI = this.meses[parseInt(mesI - 1)];
        this.data_tela_inicial = diaI + "/" + mesI + "/" + anoI;
      } else {
        let m = new Date(localStorage.dt_inicial);
        let d = m.getDate();
        if (d < 10) {
          d = "0" + d;
        }
        let mesA = m.getMonth();
        let a = m
          .getFullYear()
          .toString()
          .substring(2);
        var mes = this.meses[mesA];
        this.data_tela_inicial = d + "/" + mes + "/" + a;
      }
      //--------------------------------------------------------
      this.data_tela_final = new Date(
        localStorage.dt_final,
      ).toLocaleDateString();
      if (this.data_tela_final == "Invalid Date") {
        localStorage.dt_final = funcoesPadroes.getDataFinal();
        var mesF = localStorage.dt_final.substring(0, 2);
        var diaF = localStorage.dt_final.substring(3, 5);
        var anoF = localStorage.dt_final.substring(6, 10);
        mesF = this.meses[parseInt(mesF - 1)];
        this.data_tela_final = diaF + "/" + mesF + "/" + anoF;
      } else {
        let mF = new Date(localStorage.dt_final);
        let dF = mF.getDate();
        if (dF < 10) {
          dF = "0" + dF;
        }
        let mesAF = mF.getMonth();
        let aF = mF
          .getFullYear()
          .toString()
          .substring(2);
        let mesF = this.meses[mesAF];
        this.data_tela_final = dF + "/" + mesF + "/" + aF;
      }
    }, 2000); //Aciona setInterval
    this.detectar();

    this.validacaoAtividade();
  },

  mounted() {
    // this.caminho      = localStorage.nm_caminho_logo_empresa;
    //this.caminho = '';
  },
  destroyed() {
    clearInterval(this.polling);
  },

  methods: {
    fechaPopup() {
      this.popupData = false;
    },
    async clickTab() {
      if (this.tab == "Home") {
        this.$router.push({ name: "home" });
      }

      localStorage.cd_menu = 0;
      localStorage.nm_identificacao_api = "";
      localStorage.cd_api = 0;
      localStorage.cd_tipo_consulta = 0;
      await Rota.apiMenu(this.tab);
    },
    async validacaoAtividade() {
      let dados_menu = await Menu.montarMenu(localStorage.cd_empresa, 0, 685);

      localStorage.cd_parametro = 0;

      let dados = await Procedimento.montarProcedimento(
        localStorage.cd_empresa,
        localStorage.cd_cliente,
        dados_menu.nm_identificacao_api,
        dados_menu.nm_api_parametro,
      );
      if (dados[0].ds_tabsheet) {
        this.menuTabs = JSON.parse(dados[0].ds_tabsheet);
      }
      //
    },

    onInformativo() {
      alert("buscando o componente listar o informativo !");

      this.ic_informativo = !this.ic_informativo;

      if (this.ic_informativo == true) {
        localStorage.ic_etapa_processo = "N";
      } else {
        localStorage.ic_etapa_processo = "S";
        //this.$router.push({ name: 'home' });
      }

      //this.$emit('validaEtapa', localStorage.ic_etapa_processo);
    },

    onSuporte() {},

    onAtividade() {
      this.ic_atividade = !this.ic_atividade;

      //this.$router.push({
      //  name: "consultaAtividade"
      // // query: { redirect: this.$route.path }
      // });
    },
    onAniversariantes() {
      alert("buscando o componente listar aniversariantes !");
    },
    onMensagem() {
      alert("buscando o componente listar Mensagens !");
    },
    atualizaData() {
      this.dt_inicial = new Date(localStorage.dt_inicial).toLocaleDateString();
      this.dt_final = new Date(localStorage.dt_final).toLocaleDateString();
    },
    detectar() {
      if (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
      ) {
        this.celular = 1;
      } else {
        this.celular = 0;
      }
    },

    pegaVideo() {
      var caminho_video = "gestaoconsorcio.mp4";

      var video = "https://www.egisnet.com.br/Videos/gbs/" + caminho_video;
      return video;
    },

    selecaoPeriodoData() {
      if (this.popupData == true) {
        this.popupData = false;
      } else if (this.popupData == false) {
        this.popupData = true;
      }
    },

    pegaImg() {
      this.caminho = localStorage.nm_caminho_logo_empresa;
      var imagem = "https://www.egisnet.com.br/img/" + this.caminho;
      return imagem;
    },

    popup() {
      if (this.alert == true) {
        this.alert = false;
      } else {
        this.alert = true;
      }
    },

    onPeriodoClick() {
      this.$router.push({
        name: "selecao-periodo",
        //query: { redirect: this.$route.path }
      });
    },

    onModuloClick() {
      localStorage.cd_menu = 6543;
      localStorage.nm_identificacao_api = "Empresa/Modulo";
      localStorage.cd_api = 52;
      localStorage.cd_tipo_consulta = 0;

      if (this.$store._mutations.SET_ConfigUsuario.ic_login_painel == "S") {
        this.$router.push({ name: "selecao-modulo-card" });
        return;
      }
      this.$router.push({
        name: "selecao-modulo",
        //query: { redirect: this.$route.path }
      });
    },
    onContatoClick() {
      this.collapse = true;
    },

    onEmpresaClick() {
      localStorage.cd_menu = 6542;
      localStorage.nm_identificacao_api = "51/54";
      localStorage.cd_api = 51;
      localStorage.cd_tipo_consulta = 0;

      this.$router.push({
        name: "selecao-empresa",
        // query: { redirect: this.$route.path }
      });
    },

    onLogoutClick() {
      auth.logOut();
      this.$router.replace({
        name: "login-form",
        //query: { redirect: this.$route.path }
        //query: { redirect: '/home' }
      });
    },
    onUsuarioClick() {
      this.$router.push({
        name: "config-usuario",
        // query: { redirect: this.$route.path }
      });
    },
  },
};
</script>

<style lang="scss">
@import "../themes/generated/variables.base.scss";
@import "../dx-styles.scss";
@import url("../views/views.css");

.text-empresa-cor {
  color: var(--cor-principal) !important;
}
.bg-empresa-cor {
  background: var(--cor-principal) !important;
  color: white;
}

.header-component {
  flex: 0 0 auto;
  background: white;
  z-index: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.24);

  .dx-toolbar .dx-toolbar-item.menu-button > .dx-toolbar-item-content .dx-icon {
    color: var(--cor-principal) !important;
  }
}

.dx-toolbar.header-toolbar .dx-toolbar-items-container .dx-toolbar-after {
  padding: 0 40px;

  .screen-x-small & {
    padding: 0 20px;
  }
}

.dx-toolbar .dx-toolbar-item.dx-toolbar-button.menu-button {
  width: $side-panel-min-width;
  text-align: center;
  padding: 0;
}

.header-title .dx-item-content {
  padding: 0;
  margin: 0;
}

.dx-theme-generic {
  .dx-toolbar {
    padding: 10px 0;
  }

  .user-button > .dx-button-content {
    padding: 0px;
  }

  .logogbs {
    width: 287;
  }
}
.img {
  max-width: 250px;
  max-height: 60px;
  width: auto;
  height: auto;
  padding-left: 10%;
}
.video {
  width: 500px;
  height: auto;
}

.collapse {
  width: 100%;
  position: absolute;
  float: left;
}

.collapse-card {
  height: 100%;
}

.data-header {
  text-align: center;
  width: 300px !important;
  margin-top: 10px;
}

.btn {
  margin-top: -10px;
  margin-right: 10px;
}

.badge {
  background-color: orangered;
  color: white;
  border-radius: 10px;
  margin-top: 1px;
  margin-left: 30px;
  margin-bottom: 1px;
  padding-top: 2px;
  padding-bottom: 1px;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 10px;
}

.dx-button.dx-button-gbs {
  background-color: rgb(80, 255, 246);
}

.dx-button.dx-button-gbs_red {
  background-color: rgb(255, 80, 124);
}

.dx-button.dx-button-gbs_orange {
  background-color: rgb(80, 255, 246);
}

.dx-button.dx-button-outro {
  background-color: rgb(80, 255, 246);
}
.tab-header {
  width: 50vw;
  height: 30px;
  border-radius: 0px 3px 3px 0px;
}
.dt-storage {
  width: auto;
}
#dt-response {
  width: 0px;
  height: 0px;
  visibility: hidden;
  padding: 0;
  display: none;
  margin: 0;
  min-height: 0px !important;
  max-height: 0 !important;
}

.lista-menu {
  height: 50px;
}
@media (max-width: 1200px) {
  .tab-header {
    width: 50vw;
  }
}
@media (max-width: 1024px) {
  .tab-header {
    width: 50vw;
  }
}
@media (max-width: 768px) {
  .tab-header {
    width: 100vw;
  }
  .dt-storage {
    display: none;
    width: 0;
    height: 0;
  }
  #dt-response {
    visibility: visible;
    width: 200px;
    padding: 8px 16px;
    display: block;
  }
  .q-hoverable:hover > .q-focus-helper {
    background: currentColor;
    opacity: 0;
  }
  .lista-menu {
    height: 100px;
  }
}
@media (max-width: 480px) {
  .tab-header {
    width: 100vw;
  }
}
</style>
